import axiosInstance from '../utils/axios.config';
import { LoginCredentials, User } from '../types';

class AuthService {
  async login(credentials: LoginCredentials): Promise<User> {
    try {
    //   const { data } = await axiosInstance.post<User>('/login', credentials);
    
    if  (credentials.email === 'doc-admin' && credentials.password === 'aspFound@1996') {
      const data = {
          username: 'naveen',
          email: 'admin',
          role: 'doctor',
          // Add other user properties as needed
        };
        return data; 
      } else if (credentials.email === 'sales-admin' && credentials.password === 'aspFound@1996'){
        const data = {
          username: 'Fabian',
          email: 'admin',
          role: 'sales',
          // Add other user properties as needed
        };
        return data;
      }else if (credentials.email === 'naveen' && credentials.password === 'aspFound@1996'){
      const data = {
        username: 'naveen',
        email: 'admin',
        role: 'doctor',
      };
      return data;
    }else if (credentials.email === 'arunachalam' && credentials.password === 'aspFound@1996'){
        const data = {
          username: 'arunachalam',
          email: 'admin',
          role: 'doctor',
        
        };
        return data;
      }else {
        throw new Error('Invalid credentials');
      }

    } catch (error) {
      throw this.handleError(error);
    }
  }

  async logout(): Promise<void> {
    try {
      // await axiosInstance.post('/logout');
      console.log("logout successful");
      
    } catch (error) {
      console.error('Logout error:', error);
    }
  }

  private handleError(error: any): Error {
    if (error.response) {
      throw new Error(error.response.data.message || 'An error occurred');
    }
    // throw new Error('Network error occurred');
    throw new Error("Invalid Credentials");
  }
}

const authService = new AuthService();
export default authService;